/**
 * Application rollout and runtime configuration resolvers.
 *
 * In PRODUCTION (NODE_ENV === 'production'):
 * - Rollout is strictly owned by build/deployment configuration (REACT_APP_ENTERPRISE_V2).
 * - Product Mode is strictly owned by build/deployment configuration (REACT_APP_PRODUCT_MODE).
 * - localStorage overrides are strictly ignored to prevent client-side security bypasses.
 *
 * In DEVELOPMENT / TEST (NODE_ENV !== 'production'):
 * - localStorage overrides ('tkp_enterprise_v2', 'tkp_product_mode') are permitted for developer testing.
 */

export function resolveEnterpriseV2(
  env = process.env,
  storage = typeof window !== 'undefined' ? window.localStorage : null
) {
  const isProd = env.NODE_ENV === 'production';
  if (isProd) {
    return env.REACT_APP_ENTERPRISE_V2 === 'true';
  }
  if (storage && typeof storage.getItem === 'function') {
    const override = storage.getItem('tkp_enterprise_v2');
    if (override !== null) {
      return override === 'true';
    }
  }
  return env.REACT_APP_ENTERPRISE_V2 === 'true';
}

export function resolveProductMode(
  env = process.env,
  storage = typeof window !== 'undefined' ? window.localStorage : null
) {
  const isProd = env.NODE_ENV === 'production';
  if (isProd) {
    return env.REACT_APP_PRODUCT_MODE || 'DEMO';
  }
  if (storage && typeof storage.getItem === 'function') {
    const override = storage.getItem('tkp_product_mode');
    if (override) {
      return override;
    }
  }
  return env.REACT_APP_PRODUCT_MODE || 'DEMO';
}
